import React from 'react';
import { View, StyleSheet } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useTheme } from 'react-native-paper';
import { MasteryVisualization } from '../components/ai/MasteryVisualization';
import { useAppSelector } from '../store';
import { selectMasteryStates } from '../store/slices/aiProfileSlice';
import { logger } from '../utils/logger';

// Mock skill categories for demonstration
const mockSkillCategories = [
  {
    id: 'brewing',
    name: 'Brewing Techniques',
    description: 'Core brewing methods and techniques',
    color: '#2196F3',
    icon: 'coffee',
    skills: ['espresso', 'pour-over', 'french-press', 'aeropress'],
  },
  {
    id: 'grinding',
    name: 'Grinding & Preparation',
    description: 'Coffee grinding and preparation skills',
    color: '#4CAF50',
    icon: 'settings',
    skills: ['grind-size', 'grind-consistency', 'dosing'],
  },
  {
    id: 'tasting',
    name: 'Tasting & Cupping',
    description: 'Coffee tasting and evaluation skills',
    color: '#FF9800',
    icon: 'palette',
    skills: ['cupping', 'flavor-profiling', 'quality-assessment'],
  },
  {
    id: 'equipment',
    name: 'Equipment Knowledge',
    description: 'Understanding coffee equipment and tools',
    color: '#9C27B0',
    icon: 'build',
    skills: [
      'machine-maintenance',
      'grinder-calibration',
      'temperature-control',
    ],
  },
];

export function MasteryVisualizationScreen() {
  const theme = useTheme();
  const masteryStates = useAppSelector(selectMasteryStates);

  const handleSkillSelect = (skillId: string) => {
    logger.log('Selected skill:', skillId);
    // In a real app, this would navigate to skill details
  };

  return (
    <SafeAreaView
      style={[styles.container, { backgroundColor: theme.colors.background }]}
    >
      <MasteryVisualization
        masteryStates={masteryStates}
        skillCategories={mockSkillCategories}
        onSkillSelect={handleSkillSelect}
        animationEnabled={true}
        showComparison={true}
        userId='demo_user'
        style={styles.visualization}
      />
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  visualization: {
    flex: 1,
  },
});
